import { useTranslation } from "react-i18next";
interface IProps {
  image: string;
  name: string;
  country: string;
  onClick: () => void;
}
function ProfileCardComponent(props: IProps) {
  const { i18n, t } = useTranslation();
  return (
    <div
      dir={i18n.language === "ar" ? "rtl" : "ltr"}
      className="max-w-[1316px] w-screen h-[126px] mobile:max-w-[360px] mobile:w-screen mobile:h-[100px] p-4 bg-white rounded-2xl shadow flex-col items-start gap-2 inline-flex"
    >
      <div className="self-stretch justify-between items-center inline-flex">
        <div className="justify-center items-center gap-2 flex">
          <img
            alt="avatar"
            className="w-[95px] h-[94px] mobile:w-16 mobile:h-16 rounded-full bg-200"
            src={props.image}
          />
          <div className="flex-col justify-start items-center inline-flex">
            <p className="self-stretch text-center text-zinc500 text-2xl font-arMedium">
              {props.name}
            </p>
            <p className="w-[121px] h-[39px] text-center text-zinc500 text-base font-arLight">
              {props.country}
            </p>
          </div>
        </div>
        <button
          onClick={props.onClick}
          className="p-2 bg-mint-500 rounded-xl text-white text-lg font-arMedium"
        >
          {t("app.shared.modifyData")}
        </button>
      </div>
    </div>
  );
}

export default ProfileCardComponent;
